import axios from 'axios';

const x_csrf_token = document.querySelector('[name="csrf-token"]').getAttribute('content');
export const HTTP = axios.create({
  headers: {
    common: {
      'X-CSRF-TOKEN': x_csrf_token
    }
  }
})

// export default {
//   get: function(resource, id, success, error) {
//     HTTP_AXIOS.get(`/${resource}/${id}.json`).then(
//       response => { 
//         if (success && typeof success == 'function'){
//           success(response.data);
//         } else {
//           // toastr.success('Saved!');
//         }
//       }, response => { 
//         if (error && typeof error == 'function'){
//           error(response);
//         } else {
//           // toastr.error('Error. Try to refresh.');
//         }
//       }
//     )
//   },

//   post: function(resource, params, success, error) {
//     HTTP_AXIOS.post(`/${resource}.json`, params).then(
//       response => { 
//         if (success && typeof success == 'function'){
//           success(response.data);
//         } else {
//           // toastr.success('Saved!');
//         }
//       }, response => { 
//         if (error && typeof error == 'function'){
//           error(response);
//         } else {
//           // toastr.error('Error. Try to refresh.');
//         }
//       }
//     )
//   },

//   patch: function(resource, id, params, success, error) {
//     HTTP_AXIOS.patch(`/${resource}/${id}.json`, params).then(
//       response => { 
//         if (success && typeof success == 'function'){
//           success(response.data);
//         } else {
//           // toastr.success('Saved!');
//         }
//       }, response => { 
//         if (error && typeof error == 'function'){
//           error(response);
//         } else {
//           // toastr.error('Error. Try to refresh.');
//         }
//       }
//     )
//   }  
// }